import { useCallback, useState } from 'react'
import { AmplitudeRenderer } from '@renderer/utils/amplitude.renderer.ts'
import { Button } from '@highlight/ui'
import OverlayIpcRenderer from '@renderer/ipc/OverlayIpc.renderer'
import { Toast, useToast } from '../index'

interface ErrorToastProps {
  toastId: string
  title: string
  message: string
  serverName?: string
  debugInfo?: Record<string, unknown>
}

export const ErrorToast = ({ toastId, message, debugInfo }: ErrorToastProps) => {
  const toast = useToast()
  const [copiedDebugInfo, setCopiedDebugInfo] = useState(false)

  const handleCopyDebugInfo = useCallback(async () => {
    if (!debugInfo) return
    try {
      await OverlayIpcRenderer.writeTextToClipboard(JSON.stringify(debugInfo, null, 2))
      setCopiedDebugInfo(true)
      setTimeout(() => setCopiedDebugInfo(false), 2000)
    } catch (err) {
      console.error('Failed to copy debug info:', err)
    }
  }, [debugInfo])

  return (
    <Toast toastId={toastId}>
      <Toast.Content>
        <Toast.Description>{message}</Toast.Description>
        <Toast.Actions>
          {debugInfo && (
            <Button size="sm" variant="outline" onClick={handleCopyDebugInfo}>
              {copiedDebugInfo ? 'Copied!' : 'Copy Debug Info'}
            </Button>
          )}
          <Button
            size="sm"
            variant="primary"
            onClick={() => {
              toast.dismiss(toastId)
              window.open('https://discord.gg/nf6PvqRjRz', '_blank', 'noopener,noreferrer')
              AmplitudeRenderer.trackEvent('Error Toast', {
                action: 'Report in Discord',
              })
            }}
          >
            Report in Discord
          </Button>
        </Toast.Actions>
      </Toast.Content>
    </Toast>
  )
}
